import { TProductAvailability } from "lib/@types/service/store/shared";

import { DeliveryPromiseTypes } from "./enums";

export const shouldDisableAddToCart = (
    productAvailability?: null | TProductAvailability,
): boolean => {
    if (
        productAvailability?.deliveryPromiseType &&
        [
            DeliveryPromiseTypes.AvailableForS2S,
            DeliveryPromiseTypes.AvailableForHomeDelivery,
        ].includes(productAvailability?.deliveryPromiseType)
    ) {
        return false;
    }

    if (!productAvailability?.realTimeStockAvailable && productAvailability?.enableAddToCart) {
        return false;
    }

    if (productAvailability?.realTimeStockAvailable && productAvailability?.realTimeStock! > 0) {
        return false;
    }

    return true;
};
